import type { IconData } from '@stacksjs/iconify-core'

export const pin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12.626 11.346l-.184-1.036l4.49-4.491l-2.851-2.852l-4.492 4.49l-1.035-.184a5.05 5.05 0 0 0-2.734.269l6.538 6.537a5.05 5.05 0 0 0 .268-2.733m-4.25 1.604L2.67 18.654a1.008 1.008 0 0 1-1.426-1.426l5.705-5.704L2.67 7.245a7.05 7.05 0 0 1 6.236-1.958l3.747-3.747a2.017 2.017 0 0 1 2.853 0l2.852 2.853a2.017 2.017 0 0 1 0 2.852l-3.747 3.747a7.05 7.05 0 0 1-1.958 6.236z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pin
